<ng-template #linkContent>
  <span *ngIf="text"
        [innerHTML]="text"></span>
  <ng-content></ng-content>
</ng-template>


<a (click)="onClick()"
   *ngIf="isInternal; else external"
   [class.selected]="isActive"
   [fragment]="fragment"
   [queryParams]="queryParams"
   [routerLink]="link"
   [target]="targetLink"
   class="link-internal {{cssClass}}"
   role="navigation"
   [attr.aria-label]="text || link"
>

  <ng-container *ngTemplateOutlet="linkContent"></ng-container>
</a>

<ng-template #external>
  <a [attr.href]="path"
     [target]="targetLink"
     role="navigation"
     [attr.aria-label]="text || path"
     class="link-external {{cssClass}}">
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
</ng-template>
